import {
  getPageUrl as activityFeed,
  pageUrl as activityFeedPath,
} from 'src/app/[locale]/(activity-feed)/fundraising-events/[slug]/manage/live-widgets/activity-feed/paths'
import {
  getPageUrl as donate,
  pageUrl as donatePath,
} from 'src/app/[locale]/(public)/donate/[channel]/[receiver-type]/[slug]/paths'
import { getPageUrl as error403, pageUrl as error403Path } from 'src/app/[locale]/403/paths'
import {
  getPageUrl as fundraisingEventForwarding,
  pageUrl as fundraisingEventForwardingPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/forwarding/paths'
import {
  getPageUrl as fundraisingEventPublicPage,
  pageUrl as fundraisingEventPublicPagePath,
} from 'src/app/[locale]/(standard)/(receiver-page)/fundraising-events/[slug]/paths'
import {
  getPageUrl as fundraisingEventThankYou,
  pageUrl as fundraisingEventThankYouPath,
} from 'src/app/[locale]/(public)/fundraising-events/[slug]/thank-you/paths'
import {
  getPageUrl as fundraisingEventThankYouModal,
  pageUrl as fundraisingEventThankYouModalPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/@modal/(..)thank-you/paths'
import {
  getPageUrl as iframeDonate,
  pageUrl as iframeDonatePath,
} from 'src/app/[locale]/(public)/donate/iframe/[receiver-type]/[slug]/paths'
import {
  getWidgetModalUrl as liveWidgetsConfig,
  pageUrl as liveWidgetsConfigPath,
  getPageUrl as liveWidgetsOverview,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/paths'
import {
  getPageUrl as liveWidgetsDonationAlert,
  pageUrl as liveWidgetsDonationAlertPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/donation-alert/paths'
import {
  getPageUrl as liveWidgetsLastComment,
  pageUrl as liveWidgetsLastCommentPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/last-comment/paths'
import {
  getPageUrl as liveWidgetsProgress,
  pageUrl as liveWidgetsProgressPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/progress/paths'
import {
  getPageUrl as liveWidgetsProjectLogos,
  pageUrl as liveWidgetsProjectLogosPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/project-logos/paths'
import {
  getPageUrl as liveWidgetsStandard,
  pageUrl as liveWidgetsStandardPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/standard/paths'
import {
  getPageUrl as liveWidgetsTopDonation,
  pageUrl as liveWidgetsTopDonationPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/top-donation/paths'
import {
  getPageUrl as liveWidgetsTopDonor,
  pageUrl as liveWidgetsTopDonorPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/top-donor/paths'
import {
  getPageUrl as liveWidgetsTotal,
  pageUrl as liveWidgetsTotalPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/total/paths'
import {
  getPageUrl as liveWidgetsVoting,
  pageUrl as liveWidgetsVotingPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/voting/paths'
import {
  getPageUrl as liveWidgetsWebhook,
  pageUrl as liveWidgetsWebhookPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/webhook/paths'
import {
  getPageUrl as manageProjects,
  pageUrl as manageProjectsPath,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/projects/paths'
import {
  getPageUrl as sharingOptionsModal,
  pageUrl as sharingOptionsModalPath,
} from 'src/app/[locale]/(standard)/(receiver-page)/fundraising-events/[slug]/@modal/sharing-options/paths'
import {
  getPageUrl as streambotTotal,
  pageUrl as streambotTotalPath,
} from 'src/app/[locale]/(public)/streambot/fundraising-events/[slug]/total/paths'
import {
  getPageUrl as streambotVoting,
  pageUrl as streambotVotingPath,
} from 'src/app/[locale]/(public)/streambot/fundraising-events/[slug]/voting/paths'
import {
  getPageUrl as streambotWidget,
  pageUrl as streambotWidgetPath,
} from 'src/app/[locale]/(public)/streambot/fundraising-events/[slug]/[widget]/paths'
import type { Url } from 'next/dist/shared/lib/router/router'

function normaliseUrl(url: string) {
  let url_ = url.split('?')[0]!
  try {
    const u = new URL(url)
    url_ = u.pathname
  } catch {}
  return url_
}

// Collect all internal paths
const internalPaths = [
  activityFeedPath,
  donatePath,
  error403Path,
  fundraisingEventForwardingPath,
  fundraisingEventPublicPagePath,
  fundraisingEventThankYouPath,
  fundraisingEventThankYouModalPath,
  iframeDonatePath,
  liveWidgetsConfigPath,
  liveWidgetsDonationAlertPath,
  liveWidgetsLastCommentPath,
  liveWidgetsProgressPath,
  liveWidgetsProjectLogosPath,
  liveWidgetsStandardPath,
  liveWidgetsTopDonationPath,
  liveWidgetsTopDonorPath,
  liveWidgetsTotalPath,
  liveWidgetsVotingPath,
  liveWidgetsWebhookPath,
  manageProjectsPath,
  sharingOptionsModalPath,
  streambotTotalPath,
  streambotVotingPath,
  streambotWidgetPath,
].map((path) => {
  const cleanedPath = normaliseUrl(path).replace(/\/\([^)]+\)/g, '')
  const regexPattern = cleanedPath.replace(/\[[^\]]+\]/g, '[^/]+')
  const regex = new RegExp(`^${regexPattern}$`)
  return regex
})

// eslint-disable-next-line import/exports-last
export function urlToString(url: Url) {
  if (typeof url === 'string') return url
  return `${url.pathname}${url.hash ? `#${url.hash}` : ''}`
}

/**
 * Checks if the provided URL matches any of the internal paths
 * @param url - The URL to check
 * @returns true if the URL matches an internal path, false otherwise
 */
// eslint-disable-next-line import/exports-last
function isInternalUrl(url: Url): boolean {
  const strUrl = urlToString(url)
  if (!strUrl) return false
  if (strUrl.startsWith('javascript:')) return false
  if (strUrl) if (strUrl.startsWith('#')) return true
  // Normalize URL by stripping query string
  const normalizedUrl = normaliseUrl(strUrl)

  return !!internalPaths.find((regex) => regex.test(normalizedUrl.split('#')[0]!))
}

const Routes = {
  activityFeed,
  donate,
  error403,
  fundraisingEventPublicPage,
  fundraisingEventThankYou,
  fundraisingEventForwarding,
  iframeDonate,
  liveWidgetsConfig,
  liveWidgetsOverview,
  liveWidgetsTopDonation,
  liveWidgetsTopDonor,
  liveWidgetsTotal,
  liveWidgetsWebhook,
  liveWidgetsDonationAlert,
  liveWidgetsVoting,
  liveWidgetsLastComment,
  liveWidgetsProgress,
  liveWidgetsProjectLogos,
  liveWidgetsStandard,
  manageProjects,
  streambotVoting,
  streambotWidget,
  streambotTotal,
  fundraisingEventThankYouModal,
  sharingOptionsModal,
} as const

export default Routes

export { isInternalUrl }
